export default __webpack_public_path__ + "static/media/Aura-Egg__28.7ab493d6.png";